import { useState } from 'react';
import { makeDefaultRange14 } from '../utils/dateRanges';

export default function useDateRange() {
  const initial = makeDefaultRange14();
  const [dateRange, setDateRange] = useState(initial);
  const [draftRange, setDraftRange] = useState(initial);

  const applyDateRange = (r) => {
    if (!r || (!r.start && !r.end)) {
      setDateRange(makeDefaultRange14());
    } else {
      setDateRange(r);
    }
  };

  return { dateRange, draftRange, setDraftRange, applyDateRange };
}
